var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useContext, createContext, useReducer } from "react";
;
var dispatchFn = function (state, action) {
    if (Array.isArray(action)) {
        return action.reduce(function (acc, curr) { return dispatchFnSwitch(acc, curr); }, __assign({}, state));
    }
    return dispatchFnSwitch(state, action);
};
var dispatchFnSwitch = function (state, action) {
    switch (action.type) {
        case "SET_HEADER_WIDTH": {
            var _a = action.payload, index = _a.index, width = _a.width;
            var header = __assign({}, state.headers[index]);
            header.width = width;
            var headers = Array.from(state.headers);
            headers[index] = header;
            return __assign(__assign({}, state), { headers: headers });
        }
        // case "TOGGLE_ROW_SELECT": {
        //   const { rowStart } = action.payload;
        //   const selected = Array.from(state.selected);
        //   return {
        //     ...state,
        //     rows,
        //   };
        // }
        case "SET_UPDATES": {
            var updates = action.payload.updates;
            state.updates = updates;
            return state;
        }
        case "SET_ROWS": {
            var rows = action.payload.rows;
            state.rows = rows;
            return state;
        }
        default:
            return state;
    }
};
var defaultState = {
    headers: [],
    rows: {},
    selected: [],
    updates: {},
};
var TableContext = createContext(__assign(__assign({}, defaultState), { dispatch: function () { return null; } }));
TableContext.displayName = "TableContext";
export var useTableContext = function () {
    return useContext(TableContext);
};
var TableDispatch = createContext(function () { return null; });
TableDispatch.displayName = "TableDispatch";
export var useTableDispatch = function () {
    return useContext(TableDispatch);
};
export var TableProvider = function (_a) {
    var children = _a.children, headers = _a.headers, rows = _a.rows, selected = _a.selected;
    var _b = useReducer(dispatchFn, __assign(__assign({}, defaultState), { headers: headers, rows: rows, selected: selected })), _c = _b[0], stateRows = _c.rows, stateHeaders = _c.headers, stateSelected = _c.selected, updates = _c.updates, dispatch = _b[1];
    useEffect(function () {
        dispatch({
            type: "SET_ROWS",
            payload: { rows: rows }
        });
    }, [rows]);
    useEffect(function () {
        console.log({ stateRows: stateRows });
    }, [stateRows]);
    return (React.createElement(TableDispatch.Provider, { value: dispatch },
        React.createElement(TableContext.Provider, { value: { rows: stateRows, headers: stateHeaders, selected: stateSelected, updates: updates, dispatch: dispatch } }, children)));
};
